import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  MY_SURVEYS: {
    id: 'MySurveys.mySurveys',
    defaultMessage: 'My Surveys',
    description: '[Type: Label][Vis.: low] - My surveys section of nav bar',
  },
});

const MySurveys = () => {
  const url = createURL('/home/', { ut_source: 'header' });
  const title = t(COPY.MY_SURVEYS);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.MY_SURVEYS} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.MY_SURVEYS} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default MySurveys;
export { MySurveys };
